import FEGORender from '@futuweb/fego-render';
import * as browser from '@futuweb/tool-browser';
const { useBehaviour } = require('@fegobull/webapi').use;

import { useFego } from './useFego';
export const useRateMethod = () => {
    const getRateClass = (rate) => {
        rate = parseFloat(rate);
        if (rate > 0) {
            return 'isUp';
        }

        if (rate < 0) {
            return 'isDown';
        }
        return '';
    };

    const getRateSymbol = (rate) => {
        return parseFloat(rate) > 0 ? '+' : '';
    };

    return {
        /** 获取涨幅的涨跌类 */
        getRateClass,
        /** 获取涨幅的涨跌标识 */
        getRateSymbol
    };
};


export const useCommonMethod = () => {
    const jumpToFund = (evt, newCode, tab = 1) => {
        const { isRender } = useFego();
        if (!newCode || !isRender.value) {
            return;
        }
        const { ftReport } = FEGORender.plugins;
        const { runBehaviour } = useBehaviour();
        const prefix = browser.isMoomoo() ? 'ftmm' : 'ftnn';
        const link = `${prefix}://quote/stockDetail/${newCode}/${tab}`;

        ftReport.record(evt, { $element_name: `跳转产品${newCode}` });
        runBehaviour(null, {
            type: 'jump',
            value: link
        }, evt, `跳转详情：${newCode}`);
        // window.location.href = `ftnn://quote/stockDetail/${newCode}/${tab}`;
    };

    const splitFlag = (str) => {
        if (!str) {
            return [];
        }
        return str.split('/').filter((v) => v);
    };
    return {
        /** 跳转产品详情 */
        jumpToFund,
        /** 分割亮点 */
        splitFlag
    };
};
